define('fusion/jquery', ['jquery'], function (jq) {
    return jq.noConflict(true);
});
